<template>
  <div class="flags-container">
    <img class="flag-img" src="/img/flags/poland.png" @click="setLang('pl')">
    <img class="flag-img" src="/img/flags/england.png" @click="setLang('en')">
    <img class="flag-img" src="/img/flags/france.png" @click="setLang('fr')">
    <img class="flag-img" src="/img/flags/gregoria.png" @click="setLang('gr')">
    <img class="flag-img" src="/img/flags/rusian.png" @click="setLang('ru')">
    <img class="flag-img" src="/img/flags/ukraine.png" @click="setLang('ua')">
    <img class="flag-img" src="/img/flags/spain.png" @click="setLang('es')">
  </div>
</template>

<script>

export default {
  name: "LangBar",
  methods:{
    setLang(lang){
      this.$store.commit("changeLanguage", lang)
    }
  }
}
</script>

<style scoped>
.flag-img {
  height: 30px;
  margin-left: 1rem;
  cursor: pointer;
}

@media screen and (max-width: 992px) {
  .flags-container {
    display: none;
  }
}
</style>